import type { FC, MouseEvent } from 'react';

import { ImageComponent } from '@/components/Image';

import { ScPlayButton } from './styled';

const DEFAULT_BUTTON_SIZE = 52;

interface IPlayButtonProps {
  href: string;
  size?: number;
  onClick?: (event: MouseEvent) => void;
  'data-testid'?: string;
}

export const PlayButton: FC<IPlayButtonProps> = ({
  href,
  size = DEFAULT_BUTTON_SIZE,
  onClick,
  'data-testid': dataTestId,
}) => (
  <ScPlayButton
    data-testid={dataTestId}
    href={href}
    onClick={onClick}
    size={size}
  >
    <ImageComponent
      alt="play button icon"
      height={24}
      src="/game/play-button-icon.svg"
      width={24}
    />
  </ScPlayButton>
);
